module.exports = __webpack_public_path__ + "img/cds.a2bcd900.png";